import { useState } from 'react';
import { CONFIG, api } from './_barrel.js';


        // =======================================================================
        // Create Account modal
        // =======================================================================
        function CreateAccountModal({ onClose }) {
            const [form, setForm] = useState({ company_name: '', full_name: '', email: '' });
            const [submitting, setSubmitting] = useState(false);
            const [error, setError] = useState(null);
            const [success, setSuccess] = useState(false);

            const update = (k, v) => setForm(prev => ({ ...prev, [k]: v }));

            const submit = async (e) => {
                e.preventDefault();
                setError(null);
                if (!form.company_name.trim() || !form.full_name.trim() || !form.email.trim()) {
                    setError('All fields are required.');
                    return;
                }
                setSubmitting(true);
                try {
                    const res = await fetch(`${CONFIG.apiBase}/api/v1/signup`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(form),
                    });
                    if (!res.ok) {
                        let msg = `Signup failed (HTTP ${res.status})`;
                        try {
                            const body = await res.json();
                            if (body?.error?.message) msg = body.error.message;
                            else if (body?.detail) msg = typeof body.detail === 'string' ? body.detail : JSON.stringify(body.detail);
                        } catch (_) {}
                        throw new Error(msg);
                    }
                    setSuccess(true);
                } catch (err) {
                    setError(err.message || 'Signup failed. Please try again.');
                } finally {
                    setSubmitting(false);
                }
            };

            return (
                <div style={{
                    position: 'fixed', inset: 0, background: 'rgba(5,9,16,0.62)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100,
                }} onClick={onClose}>
                    <div style={{
                        background: 'var(--zone-2)',
                        border: '1px solid var(--rule-2)',
                        padding: '32px',
                        width: '440px', maxWidth: '92vw',
                        position: 'relative',
                    }} onClick={(e) => e.stopPropagation()}>
                        <div className="font-display" style={{
                            fontSize: '14px', letterSpacing: '0.1em', textTransform: 'uppercase',
                            color: 'var(--gold)', marginBottom: '24px',
                        }}>
                            {success ? 'Request Received' : 'Create Tenant Account'}
                        </div>

                        {success ? (
                            <div>
                                <div style={{color:'var(--text)', fontSize:'14px', lineHeight:1.6, marginBottom:'20px'}}>
                                    Your account request for <b style={{color:'var(--gold)'}}>{form.company_name}</b> has been received.
                                </div>
                                <div style={{color:'var(--text-muted)', fontSize:'13px', lineHeight:1.6, marginBottom:'24px'}}>
                                    Check your inbox at <b style={{color:'var(--cyan)'}}>{form.email}</b> for a link to set your password.
                                    Once your tenant is approved by Obsidian Arc, you will be able to sign in.
                                </div>
                                <button className="btn-gold" onClick={onClose} style={{width:'100%'}}>
                                    Close
                                </button>
                            </div>
                        ) : (
                            <form onSubmit={submit}>
                                <div style={{marginBottom:'16px'}}>
                                    <label style={{display:'block', fontSize:'11px', letterSpacing:'0.09em', textTransform:'uppercase', color:'var(--text-muted)', marginBottom:'6px'}}>
                                        Company Name
                                    </label>
                                    <input
                                        type="text"
                                        value={form.company_name}
                                        onChange={e => update('company_name', e.target.value)}
                                        disabled={submitting}
                                        autoFocus
                                        style={{
                                            width:'100%', background:'var(--zone-3)', color:'var(--text)',
                                            border:'1px solid var(--rule-2)', padding:'10px 12px',
                                            fontSize:'14px', fontFamily:'Inter, sans-serif',
                                        }}
                                    />
                                </div>
                                <div style={{marginBottom:'16px'}}>
                                    <label style={{display:'block', fontSize:'11px', letterSpacing:'0.09em', textTransform:'uppercase', color:'var(--text-muted)', marginBottom:'6px'}}>
                                        Your Name
                                    </label>
                                    <input
                                        type="text"
                                        value={form.full_name}
                                        onChange={e => update('full_name', e.target.value)}
                                        disabled={submitting}
                                        style={{
                                            width:'100%', background:'var(--zone-3)', color:'var(--text)',
                                            border:'1px solid var(--rule-2)', padding:'10px 12px',
                                            fontSize:'14px', fontFamily:'Inter, sans-serif',
                                        }}
                                    />
                                </div>
                                <div style={{marginBottom:'20px'}}>
                                    <label style={{display:'block', fontSize:'11px', letterSpacing:'0.09em', textTransform:'uppercase', color:'var(--text-muted)', marginBottom:'6px'}}>
                                        Work Email
                                    </label>
                                    <input
                                        type="email"
                                        value={form.email}
                                        onChange={e => update('email', e.target.value)}
                                        disabled={submitting}
                                        style={{
                                            width:'100%', background:'var(--zone-3)', color:'var(--text)',
                                            border:'1px solid var(--rule-2)', padding:'10px 12px',
                                            fontSize:'14px', fontFamily:'Inter, sans-serif',
                                        }}
                                    />
                                </div>
                                {error && (
                                    <div style={{color:'var(--red)', fontSize:'13px', marginBottom:'16px'}}>
                                        {error}
                                    </div>
                                )}
                                <div style={{display:'flex', gap:'12px'}}>
                                    <button
                                        type="button"
                                        onClick={onClose}
                                        disabled={submitting}
                                        className="btn-gold"
                                        style={{
                                            flex:1, background:'transparent', color:'var(--text-muted)',
                                            border:'1px solid var(--rule-2)',
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        disabled={submitting}
                                        className="btn-gold"
                                        style={{flex:1}}
                                    >
                                        {submitting ? 'Submitting…' : 'Request Account'}
                                    </button>
                                </div>
                                <div style={{
                                    marginTop:'20px', fontSize:'11px', color:'var(--text-faint)',
                                    lineHeight:1.5, textAlign:'center',
                                }}>
                                    New tenants are reviewed by Obsidian Arc before activation. You will receive an email to set your password.
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            );
        }

export { CreateAccountModal };
